import type { ApiSchema } from "../../apiSchema";
import { JsonContractError, readBoolean, readInteger, readObject, readString } from "../../http/jsonDecoding";
import { readStrings } from "./selectorDecoders";
import { keptMembers } from "./keptContentMembers";

/** Shared by tool interfaces and stored input declarations. */
export function decodeToolParameter(value: unknown): ApiSchema<"ToolParameter"> {
  const parameter = readObject(value, "tool parameter");
  const kept = keptMembers(parameter, { description: (description) => readString({ description }, "description") });
  const type = readString(parameter, "type");
  switch (type) {
    case "boolean":
      return { type, ...kept, ...keptMembers(parameter, { default: (defaultValue) => readBoolean({ default: defaultValue }, "default") }) };
    case "integer":
    case "number": {
      const number = (value: unknown) => type === "integer" ? readInteger({ number: value }, "number") : readNumber(value);
      return { type, ...kept, ...keptMembers(parameter, { minimum: number, maximum: number, default: number }) };
    }
    case "string":
      return { type, ...kept, ...keptMembers(parameter, { pattern: (pattern) => readString({ pattern }, "pattern"), default: (defaultValue) => readString({ default: defaultValue }, "default") }) };
    case "enum":
      return { type, values: readStrings(parameter["values"], "enum values"), ...kept, ...keptMembers(parameter, { default: (defaultValue) => readString({ default: defaultValue }, "default") }) };
    default:
      throw new JsonContractError(`Unknown tool parameter type "${type}".`);
  }
}

function readNumber(value: unknown): number {
  if (typeof value !== "number" || !Number.isFinite(value)) throw new JsonContractError("Expected a finite number.");
  return value;
}
